/**
 * [ 서비스 라우트 관리 규칙 ]
 * * 1. 도메인 단위로 계층 구조를 유지합니다. (예: SCENE, AUTH, CHAT 등)
 * 2. 단순 경로는 문자열 상수로 정의합니다.
 * 3. 파라미터가 포함된 경로는 'PATH'와 'GO'를 포함한 객체로 관리합니다.
 * - PATH: Route 컴포넌트의 path 속성에 사용 (패턴 정의)
 * - GO: useNavigate나 Link의 to 속성에 사용 (실제 이동용 함수)
 * 4. 모든 경로는 유지보수를 위해 'as const'를 사용하여 읽기 전용으로 관리합니다.
 * @example
 * 1. 단순 경로 정의
 * MAIN: '/scene',
 * 2. 파라미터 경로 정의
 * PREVIEW: {
 * PATH: '/scene/:sceneId/preview',
 * GO: (sceneId: string) => `/scene/${sceneId}/preview`,
 * }
 */
export const ROUTES = {
  SCENE: {
    MAIN: '/scene',
    INTRO: '/scene/intro',
    SETTING: '/scene/setting',
    CAST_RELATIONSHIPS: '/scene/cast-relationships',
    CONTACT: '/scene/contact-us',
    PREVIEW_DETAIL: {
      PATH: '/scene/:sceneId/preview',
      GO: (sceneId: string) => `/scene/${sceneId}/preview`
    },
    COMMENTS_DETAIL: {
      PATH: '/scene/:adaptedFictionEditionId/comments/:commentId',
      GO: (adaptedFictionEditionId: string, commentId: string) =>
        `/scene/${adaptedFictionEditionId}/comments/${commentId}`
    },
    ORIGINAL_EPISODES: {
      PATH: '/scene/:sceneId/original-episodes',
      GO: (sceneId: string) => `/scene/${sceneId}/original-episodes`
    }
  }
} as const;
